import React from "react";
import classnames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import PlayVideoSvg from "../assets/play-video.svg?react";

const muiColorSet = new Set(["default", "inherit", "primary", "secondary"]);

const iconMap = {
  videoPlay: PlayVideoSvg,
};

const getIconFromOverride = (override) => {
  if (!override) return undefined;
  const IconComponent = iconMap[override];
  if (!IconComponent) return undefined;
  return (
    <IconComponent
      aria-label="Play video"
      role="img"
      style={{ width: "1rem", height: "1rem" }}
    />
  );
};

const styles = (theme) => ({
  root: {
    textTransform: "none",
    fontWeight: 800,
    letterSpacing: ".02em",
    borderRadius: "16px",
    minHeight: "44px",
    transition: "all 0.25s ease",
  },
  pill: {
    borderRadius: "999px",
  },
  green: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.dark,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  white: {
    color: theme.palette.text.white,
    borderColor: "rgba(255,255,255,0.65)",
    "&:hover": {
      borderColor: theme.palette.text.white,
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  },
  blurLight: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    isolation: "isolate",
    color: theme.palette.text.white,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.24)",
    },
  },
  blurDark: {
    backgroundColor: "rgba(0, 0, 0, 0.18)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    isolation: "isolate",
    color: theme.palette.text.white,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.3)",
    },
  },
});

const CustomButton = React.forwardRef((props, ref) => {
  const {
    classes,
    className,
    color,
    pill,
    disableElevation,
    startIconOverride,
    endIconOverride,
    startIcon,
    endIcon,
    ...rest
  } = props;

  const customColorClass =
    color && !muiColorSet.has(color) && classes[color] ? classes[color] : null;
  const muiColor = muiColorSet.has(color) ? color : undefined;
  const resolvedStartIcon = getIconFromOverride(startIconOverride) || startIcon;
  const resolvedEndIcon = getIconFromOverride(endIconOverride) || endIcon;

  return (
    <Button
      ref={ref}
      className={classnames(
        classes.root,
        pill ? classes.pill : null,
        customColorClass,
        className
      )}
      color={muiColor}
      disableElevation={disableElevation ?? true}
      startIcon={resolvedStartIcon}
      endIcon={resolvedEndIcon}
      {...rest}
    />
  );
});

export default withStyles(styles, { withTheme: true })(CustomButton);
